import { Link as RouterLink, useParams } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import ArrowBackIcon from '@mui/icons-material/esm/ArrowBack';
import WorkerFieldWorkspacePage from './WorkerFieldWorkspacePage';

type AdminWorkerScreen = 'home' | 'current' | 'upcoming' | 'performance' | 'emergency';

interface AdminWorkerAccountViewPageProps {
  screen?: AdminWorkerScreen;
}

export default function AdminWorkerAccountViewPage({ screen = 'home' }: AdminWorkerAccountViewPageProps) {
  const { workerId } = useParams();

  if (!workerId) {
    return <Alert severity="error">Worker was not found.</Alert>;
  }

  const basePath = `/field/workers/${workerId}`;
  const screens: Array<{ label: string; screen: AdminWorkerScreen; to: string }> = [
    { label: 'Home', screen: 'home', to: basePath },
    { label: 'Current Task', screen: 'current', to: `${basePath}/current` },
    { label: 'Work Plan', screen: 'upcoming', to: `${basePath}/upcoming` },
    { label: 'Performance', screen: 'performance', to: `${basePath}/performance` },
    { label: 'Safety', screen: 'emergency', to: `${basePath}/emergency` },
  ];

  return (
    <Stack spacing={1.5}>
      <Button component={RouterLink} to="/field/workers" startIcon={<ArrowBackIcon />} sx={{ alignSelf: 'flex-start', fontWeight: 900 }}>
        All worker folders
      </Button>
      <Stack direction="row" spacing={1} sx={{ overflowX: 'auto' }}>
        {screens.map((item) => (
          <Button
            key={item.screen}
            component={RouterLink}
            to={item.to}
            variant={screen === item.screen ? 'contained' : 'outlined'}
            sx={{ flex: '0 0 auto', borderRadius: 1, fontWeight: 900 }}
          >
            {item.label}
          </Button>
        ))}
      </Stack>
      <WorkerFieldWorkspacePage view={screen} workerId={workerId} navigationBasePath={basePath} />
    </Stack>
  );
}
